import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Stack } from '../../component-stack';
import { Children, forwardRef } from 'react';
export const FormControlGroup = forwardRef(({ controls, ...props }, ref) => (_jsx(Stack, { direction: "vertical", spacing: "small-lg", ...props, ref: ref, children: Children.map(controls.map((control) => control({})), (control) => control) })));
FormControlGroup.displayName = 'FormControlGroup';
